import { Component } from '@angular/core';
import { NavController, NavParams } from 'ionic-angular';
import { WpProvider } from '../../providers/wp/wp';

/**
 * Generated class for the WeatherPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-weather',
  templateUrl: 'weather.html',
})
export class WeatherPage {

  phcApp;

  constructor(public navCtrl: NavController, public navParams: NavParams, wp: WpProvider) {
    this.phcApp = wp.app;
  }

  weatherFrame() {
    return `
      <!DOCTYPE html>
      <html>
        <head>
          <meta charset="UTF-8">
          <title>Weather Forecast</title>
          <link rel="stylesheet" href="https://maxcdn.bootstrapcdn.com/bootstrap/3.3.7/css/bootstrap.min.css" integrity="sha384-BVYiiSIFeK1dGmJRAkycuHAHRg32OmUcww7on3RYdg4Va+PmSTsz/K68vbdEjh4u" crossorigin="anonymous">
          <link rel="stylesheet" href="https://phc-dev.eventerac.com/wp-content/plugins/awesome-weather-pro/awesome-weather.css">
          <script src="https://cdnjs.cloudflare.com/ajax/libs/jquery/3.3.1/jquery.min.js"></script>
          <script src="https://phc-dev.eventerac.com/wp-content/plugins/awesome-weather-pro/js/awesome-weather-widget-frontend.js"></script>
          <style>
            html{
              background: url(${this.phcApp.location.weather_background || 'https://www.fasken.com/-/media/805bbcaefeb84072af18d3ce3e0be181.ashx'}) no-repeat;
              background-size: cover !important;
              background-position: 50% 50% !important;
              width: 100%;
              height: 100%;
            }
            .awesome-weather-wrap{
              top: 50%;
              position: absolute;
              width: 100%;
              transform: translateY(-50%);
              background: rgba(0, 0, 0, 0.7) !important;
            }
          </style>
        </head>
        <body>
          ${this.phcApp.weather}
        </body>
      </html>
    `;
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad WeatherPage');
  }

}



// WEBPACK FOOTER //
// ./src/pages/weather/weather.ts